import { all, put, takeLatest } from 'redux-saga/effects';

import { types as uncheckedCountTypes } from '../ducks/uncheckedAlertsCount';

export function * watchUncheckedAlertsCount() {
    yield takeLatest(uncheckedCountTypes.UNCHECKED_ALERTS_COUNT_GET, onUncheckedAlertsCountGet);
    yield takeLatest(uncheckedCountTypes.UNCHECKED_ALERTS_COUNT_SUCCESS, onUncheckedAlertsCountGetResponse);
}

function * onUncheckedAlertsCountGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

function * onUncheckedAlertsCountGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'unchecked_alerts_count') {
        return yield all([
            put({
                type: uncheckedCountTypes.UNCHECKED_ALERTS_COUNT_SET,
                payload: response,
            }),
        ]);
    }
}
